var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBullpenLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.878234 5.92285C0.782097 5.96986 0.782097 6.10402 0.878234 6.15102L11.9417 11.5604C11.9784 11.5784 12.0216 11.5784 12.0583 11.5604L15.3405 9.95563C15.4375 9.9082 15.4364 9.77245 15.3386 9.72655L7.62956 6.10805C7.53179 6.06215 7.53067 5.9264 7.62767 5.87897L11.5063 3.98254C11.5424 3.96491 11.5847 3.96457 11.6211 3.98163L19.6949 7.77136C19.7312 7.78842 19.7736 7.78808 19.8097 7.77045L23.1218 6.15102C23.2179 6.10402 23.2179 5.96986 23.1218 5.92285L12.0583 0.513466C12.0216 0.495511 11.9784 0.495511 11.9417 0.513466L0.878234 5.92285Z",
    fill: "#01080C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1739 10.8953C16.1739 10.8005 16.0719 10.7388 15.9852 10.7813L12.5938 12.4394C12.5497 12.461 12.5217 12.5052 12.5217 12.5535V23.3723C12.5217 23.4671 12.6238 23.5288 12.7105 23.4864L16.1018 21.8282C16.146 21.8066 16.1739 21.7624 16.1739 21.7141V10.8953Z",
    fill: "#01080C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5366 19.6598C20.4499 19.7022 20.3479 19.6406 20.3479 19.5458V8.72698C20.3479 8.67867 20.3758 8.6345 20.42 8.6129L23.8112 6.95476C23.898 6.91235 24 6.97402 24 7.06884V17.8876C24 17.9359 23.9721 17.9801 23.9279 18.0017L20.5366 19.6598Z",
    fill: "#01080C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.8876C0 17.9359 0.0279135 17.9801 0.0721027 18.0017L11.2895 23.4864C11.3762 23.5288 11.4783 23.4671 11.4783 23.3723V12.5535C11.4783 12.5052 11.4503 12.461 11.4062 12.4394L0.188767 6.95476C0.102041 6.91235 0 6.97402 0 7.06884V17.8876Z",
    fill: "#01080C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBullpenLogoIcon);
export default __webpack_public_path__ + "static/media/bullpen-logo-icon.11bfe1910071d60ad7317bae99ffb224.svg";
export { ForwardRef as ReactComponent };